import {
  ELEMENT_EXPRESSION_LOCALIZED,
  ELEMENT_EXPRESSIONS_LOCALIZED,
} from '@packages/systems/designer/actions';
import type {
  ExpressionPath,
  Type,
  TypeImplementation,
} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';
import {
  type ActionCreator,
  createAction,
} from '@packages/utilities/create-action';

export type ElementExpressionLocalizedNestedAction = Extract<
  TypeImplementation.ExpressionEditorAction,
  {
    type:
      | 'EXPRESSION_ACTION'
      | 'EXPRESSION_ASSOC_LIST_ITEM_ADDED'
      | 'EXPRESSION_ASSOC_LIST_ITEM_REMOVED'
      | 'EXPRESSION_ASSOC_LIST_ITEM_UPDATED'
      | 'EXPRESSION_ASSOC_LIST_ITEM_MOVED'
      | 'EXPRESSION_RESET_TO_PRIMARY_LOCALE';
  }
>;

export type ElementExpressionLocalizedPayload = {
  elementId: string;
  /**
   * Path on the element to the localization binding site (e.g. `[xattr]`).
   * Distinct from `action.key`, which is a path *inside* the localization
   * value itself (`[]` = replace the whole loc value; nested = subpath write
   * within that value).
   */
  expressionPath: ExpressionPath;
  localizationKey: string;
  dataType: Type;
  action: ElementExpressionLocalizedNestedAction;
};

export type ElementExpressionsLocalizedChange = {
  expressionPath: ExpressionPath;
  newExpression: Expression;
  localizationKey: string;
  dataType: Type;
};

export type ElementExpressionsLocalizedPayload = {
  elementId: string;
  changes: Array<ElementExpressionsLocalizedChange>;
};

export const elementExpressionLocalized: ActionCreator<
  typeof ELEMENT_EXPRESSION_LOCALIZED,
  ElementExpressionLocalizedPayload
> = createAction(ELEMENT_EXPRESSION_LOCALIZED);

export const elementExpressionsLocalized: ActionCreator<
  typeof ELEMENT_EXPRESSIONS_LOCALIZED,
  ElementExpressionsLocalizedPayload
> = createAction(ELEMENT_EXPRESSIONS_LOCALIZED);
